export default "/images/d4413105c7e31da73415e122a5e32763.png";